import React, { useRef } from 'react';
import classnames from 'classnames';
import { useSelector } from 'react-redux';
import TopNav from '../home/landingPage/TopNav';
import Hero from '../home/landingPage/hero';
import Categories from '../home/landingPage/categories';
import Territories from '../home/landingPage/Territories';
import SideNav from 'components/sideNav';
import { slideoutPanel } from 'components/sideNav/styles.mod.scss';
import Footer from 'components/footer';
import AsyncLeadCaptureModal from 'components/leadCaptureModal/async';
import { MutedBackground } from 'scy/Background';
import ValueProps from 'scy/ValueProps';
import MediaLogos from 'scy/MediaLogos';
import { WideContainer } from 'scy/layouts';
import { H2Alt } from 'scy/text';
import { borderBox } from 'scy/utils.mod.scss';
import { hidden, desktop_block } from 'scy/display.mod.scss';
import { desktop_accent, desktop_hero } from 'scy/text/styles.mod.scss';
import padding from 'scy/padding.mod.scss';
import { notFound } from 'shared/utils/errors';
import { subtitle as territoriesSubtitle } from 'components/home/landingPage/territories.mod.scss';
import HeadTags from './head';
import CoverageMap from './CoverageMap';
import Neighborhoods from './Neighborhoods';
import ZipCodes from './ZipCodes';
import Blurb from './Blurb';

export default function CityPage({ match, history }) {
  const valuePropsId = 'value-props';
  const panelRef = useRef();
  const toggleRef = useRef();

  const { list, loading } = useSelector(state => state.cities);
  const city = (list || []).find(city => city.slug === match.params.slug);
  if (!city && !loading) {
    return notFound('City not found');
  }

  function handleAddressSuccess() {
    history.push('/');
  }

  return (
    <div className={borderBox}>
      <HeadTags name={city} />
      <main ref={panelRef} className={slideoutPanel}>
        <TopNav valuePropsId={valuePropsId} toggleRef={toggleRef} />
        <Hero
          title={
            <div
              className={`${padding.desktop_top_md} ${
                padding.desktop_bottom_md
              }`}
            >
              Alcohol Delivery in {city.name}
            </div>
          }
          onAddressSuccess={handleAddressSuccess}
        />
        <ValueProps id={valuePropsId} />

        <MutedBackground>
          <WideContainer
            tag="section"
            className={classnames(
              padding.top_md,
              padding.bottom_md,
              padding.tablet_top_lg,
              padding.tablet_bottom_lg
            )}
          >
            <MediaLogos />
          </WideContainer>

          <WideContainer tag="section">
            <Categories />
          </WideContainer>
        </MutedBackground>

        <CoverageMap city={city} />
        <Neighborhoods neighborhoods={city.neighborhoods} />
        <ZipCodes zipCodes={city.zip_codes} />
        <Blurb blurb={city.blurb} />

        <Territories
          title={
            <H2Alt tag="h1" className={`${desktop_accent} ${desktop_hero}`}>
              Get Saucey <br />
              in {city.name}
            </H2Alt>
          }
          subtitle={
            <H2Alt
              className={`${hidden} ${desktop_block} ${territoriesSubtitle}`}
            >
              On-demand 30-min delivery or 2-day shipping
            </H2Alt>
          }
          onAddressSuccess={handleAddressSuccess}
        />
        <Footer />
        <AsyncLeadCaptureModal />
      </main>

      <SideNav panelRef={panelRef} toggleRef={toggleRef} />
    </div>
  );
}
